import CalendarIcon from "icons/CalendarIcon";
import TimerIcon from "icons/TimerIcon";
import PersonIcon from "icons/PersonIcon";
import LocationIcon from "icons/LocationIcon";
import OpenEyeIcon from "icons/OpenEyeIcon";

const HEADER_LABELS = {
    EVENT_NAME: "Nombre de evento",
    DAYS: "Días",
    TIME: "Horas",
    LOCATION: "Ubicación",
    TEACHER: "Docente/Ponente",
    STATE: "Estado"
};
const HEADERS_TABLE_LIST_ADMIN = [
    { title: HEADER_LABELS.EVENT_NAME }, 
    { title: HEADER_LABELS.DAYS, icon: <CalendarIcon/> },
    { title: HEADER_LABELS.TIME, icon: <TimerIcon/> }, 
    { title: HEADER_LABELS.TEACHER, icon: <PersonIcon/> }, 
    { title: HEADER_LABELS.LOCATION, icon: <LocationIcon/> }
];
export const HEADERS_TABLE_LIST = {
    ADMIN: [...HEADERS_TABLE_LIST_ADMIN],
    ADMIN_WITH_STATE: [
        ...HEADERS_TABLE_LIST_ADMIN,
        { title: HEADER_LABELS.STATE, icon: <OpenEyeIcon/> }
    ],
    TEACHER: [
        { title: HEADER_LABELS.EVENT_NAME }, 
        { title: HEADER_LABELS.DAYS, icon: <CalendarIcon/> },
        { title: HEADER_LABELS.TIME, icon: <TimerIcon/> }, 
        { title: HEADER_LABELS.LOCATION, icon: <LocationIcon/> }
    ]
};
export const TAB_DATA_VALUES = {
    ADMIN: {
        GENERAL: 0,
        PAST: 1,
        DRAFT: 2,
        CANCELED: 3,
        UNPROCESSED: 4
    },
    TEACHER: {
        GENERAL: 0,
        PAST: 1,
        CANCELED: 2
    }
};
export const EVENT_STATE_UNPROCESSED_TAB = {
    PENDING: "N",
    UPDATED: "A",
    PROCESSED: "C",
    UNPROCESSED: "E"
};
export const EVENT_STATE_UNPROCESSED_TAB_BY_TEXT = {
    [EVENT_STATE_UNPROCESSED_TAB.PENDING]: "Pendiente",
    [EVENT_STATE_UNPROCESSED_TAB.UPDATED]: "Actualizado",
    [EVENT_STATE_UNPROCESSED_TAB.PROCESSED]: "Procesado",
    [EVENT_STATE_UNPROCESSED_TAB.UNPROCESSED]: "No Procesado",
};
export const TAB_DATA_FIELDS = {
    ADMIN: {
        [TAB_DATA_VALUES.ADMIN.GENERAL]: "general",
        [TAB_DATA_VALUES.ADMIN.PAST]: "past",
        [TAB_DATA_VALUES.ADMIN.DRAFT]: "draft",
        [TAB_DATA_VALUES.ADMIN.CANCELED]: "canceled",
        [TAB_DATA_VALUES.ADMIN.UNPROCESSED]: "unprocessed"
    },
    TEACHER: {
        [TAB_DATA_VALUES.TEACHER.GENERAL]: "general",
        [TAB_DATA_VALUES.TEACHER.PAST]: "past",
        [TAB_DATA_VALUES.TEACHER.CANCELED]: "canceled"
    }
};
export const TAB_DATA_FOR_FILTER_TYPE = {
    ADMIN: {
        [TAB_DATA_VALUES.ADMIN.GENERAL]: 1,
        [TAB_DATA_VALUES.ADMIN.PAST]: 2,
        [TAB_DATA_VALUES.ADMIN.DRAFT]: 3,
        [TAB_DATA_VALUES.ADMIN.CANCELED]: 4,
        [TAB_DATA_VALUES.ADMIN.UNPROCESSED]: 6
    },
    TEACHER: {
        [TAB_DATA_VALUES.TEACHER.GENERAL]: 1,
        [TAB_DATA_VALUES.TEACHER.PAST]: 2,
        [TAB_DATA_VALUES.TEACHER.CANCELED]: 4
    }
};
export const RECORDS_BY_PAGE = 10;